import React from "react";
const variantClasses = {
  h1: "font-medium sm:text-[38px] md:text-[44px] text-[48px]",
  h2: "sm:text-[26px] md:text-[28px] text-[30px]",
  h3: "font-normal sm:text-[22px] md:text-[24px] text-[26px]",
  h4: "font-normal sm:text-[21px] md:text-[23px] text-[25px]",
  h5: "sm:text-[20px] md:text-[22px] text-[24px]",
  h6: "text-[20px]",
  body1: "text-[18px]",
  body2: "text-[16px]",
  body3: "font-normal text-[15px]",
  body4: "font-light text-[14px]",
  body5: "font-light text-[12px]",
};
const Text = ({ children, className, variant, as, ...restProps }) => {
  const Component = as || "span";
  return (
    <Component
      className={`${className} ${variantClasses[variant]}`}
      {...restProps}
    >
      {children}
    </Component>
  );
};

export { Text };
